import API from "../../../../../global/api";


export const requestAddShop = () => {
  return {
    type: "REQUEST_ADD_SHOP",
  };
};
export const successAddShop = (data) => {
  return {
    type: "SUCCESS_ADD_SHOP",
    payload: data,
  };
};
export const errorAddShop = () => {
  return {
    type: "ERROR_ADD_SHOP",
  };
};
export const AddShopApi = (data, handleVisible, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestAddShop());
    API.post(`/shop/add-shop`, data)
      .then((res) => {
        dispatch(successAddShop(data));
        handleVisible(res.data.message);
      }).catch((error) => {
        dispatch(errorAddShop());
        handleDangerVisible(error.response.data.message);
      });
  };
};


export const requestGetShop = () => {
  return {
    type: "REQUEST_GET_SHOP",
  };
};
export const successGetShop = (data) => {
  return {
    type: "SUCCESS_GET_SHOP",
    payload: data,
  };
};
export const errorGetAllShop = () => {
  return {
    type: "ERROR_GET_SHOP",
  };
};
export const GetShopApi = (data) => {
  return (dispatch) => {
    dispatch(requestGetShop());
    API.get(`/shop/get-shops`)
      .then((res) => {
        let data1 = res.data;
        dispatch(successGetShop(data1));
      }).catch((error) => {
        dispatch(errorGetAllShop());
      });
  };
};


export const UpdateRequestShop = () => {
  return {
    type: "UPDATE_REQUEST_SHOP",
  };
};
export const UpdateSuccessShop = (data) => {
  return {
    type: "UPDATE_SUCCESS_SHOP",
    payload: data,
  };
};
export const UpdateErrorShop = () => {
  return {
    type: "UPDATE_ERROR_SHOP",
  };
};
export const UpdateShopApi = (data, oldData) => {
  return (dispatch) => {
    dispatch(UpdateRequestShop());
    API.put(`/shop/update-shop/${oldData._id}`, {
      shopName: data.shopName,
      location: data.location,
      shopDesc: data.shopDesc,
      NTN: data.NTN,
      ownerName: data.ownerName,
      ownerNumber: data.ownerNumber,
      ownerCnic: data.ownerCnic,
    }, {}).then((res) => {
      dispatch(UpdateSuccessShop([data]));
    }).catch((error) => {
      dispatch(UpdateErrorShop());
    });
  };
};


export const DeleteRequestShop = () => {
  return {
    type: "DELETE_REQUEST_SHOP",
  };
};
export const DeleteSuccessShop = (id) => {
  return {
    type: "DELETE_SUCCESS_SHOP",
    id: id,
  };
};
export const DeleteErrorShop = () => {
  return {
    type: "DELETE_ERROR_SHOP",
  };
};
export const DeleteShopApi = (id) => {
  return (dispatch) => {
    dispatch(DeleteRequestShop());
    API.delete(`/shop/delete-shop/${id}`)
      .then((res) => {
        dispatch(DeleteSuccessShop(id));
      }).catch((error) => {
        dispatch(DeleteErrorShop());
      });
  };
};


export const RequestGetShopByArea = () => {
  return {
    type: "REQUEST_GET_SHOP_BY_AREA",
  };
};
export const SuccessGetShopByArea = (data) => {
  return {
    type: "SUCCESS_GET_SHOP_BY_AREA",
    payload: data,
  };
};
export const ErrorGetShopByArea = () => {
  return {
    type: "ERROR_GET_SHOP_BY_AREA",
  };
};
export const GetShopByAreaApi = (shopId) => {
  return (dispatch) => {
    dispatch(RequestGetShopByArea());
    API.get(`/shop/area_wise_shops/${shopId}`)
      .then((res) => {
        let data1 = res.data;
        dispatch(SuccessGetShopByArea(data1));
      }).catch((error) => {
        dispatch(ErrorGetShopByArea());
      });
  };
};
